import { render, staticRenderFns } from "./ProjectsDetails.vue?vue&type=template&id=788a1b26&scoped=true&"
import script from "./ProjectsDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsDetails.vue?vue&type=style&index=0&id=788a1b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a1b26",
  null
  
)

component.options.__file = "ProjectsDetails.vue"
export default component.exports